import { Controller } from '@hotwired/stimulus'
import { wrapViewTransition } from '../helpers/view_transitions'

// Connects to data-controller="flash"
export default class extends Controller {
  static targets = ['loader']

  DURATION = 3000

  remainingTime = this.DURATION
  paused = false

  connect () {
    // if there is a modal dialog open, move the flash inside it
    const openModalDialog = document.querySelector('dialog[open]:modal')
    if (openModalDialog && !this.element.closest('dialog')) {
      openModalDialog.appendChild(this.element)
    }

    window.requestAnimationFrame(this.animateCountdown.bind(this))

    // This helps properly reset the flash when morphing between 2 pages with the same flash
    this.element.addEventListener('turbo:before-morph-element', () => {
      this.remainingTime = this.DURATION
    })
  }

  animateCountdown (timestamp) {
    if (this.remainingTime > 0) {
      this.loaderTarget.style.width = `${this.remainingTime / this.DURATION * 100}%`
      if (this.previousTimestamp && !this.paused) {
        this.remainingTime -= timestamp - this.previousTimestamp
      }
      this.previousTimestamp = timestamp
      window.requestAnimationFrame(this.animateCountdown.bind(this))
    } else {
      this.close()
    }
  }

  close (event) {
    wrapViewTransition(() => {
      this.element.remove()
    })
  }

  pause () {
    this.paused = true
  }

  resume () {
    this.paused = false
  }
}
